<div class="asd-dialog-container">

  <!--Header-->
  <div class="modal-header heading">
    <h4 class="modal-title-custom">{{ modalHeader }}</h4>
    <button type="button" class="dialog-close-btn" aria-label="Close" (click)="closeDialog()">
      <span aria-hidden="true">&times;</span>
    </button>

  </div>
  <!--Body-->
  <div class="modal-body  text-center">
    <div class="d-flex justify-content-center">
      @if (loading) {
      <div class="d-flex justify-content-center adjust">
        <div class="loader" id="loader-4">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      }
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10 d-flex mb-3">
        <h6>
          <small class="text-muted">{{modaldescription}}</small>
        </h6>
      </div>
    </div>
    <div class="row d-flex justify-content-center">
      <!--Grid column-->
      <div class="col-lg-6 col-md-6 waves-light">
        <!--Panel-->
        <div class="card justify-content-center">
          <div class="card-header text-uppercase font-weight-bold"
            style="background: none; border: none; text-align: left;">
            <h5 class="text-uppercase font-weight-bold ">
              {{standardModuleHeader}}
            </h5>
          </div>
          <div class="card-body">
            <div class="col mx-1 wow fadeInUp ">
              @for (value of arrStandartModuleContents; track $index) {
              <div class="list-group-item d-flex align-items-center">
                <i class="fas fa-check-circle iconColor mr-1 margin"></i>
                <h6 class="align"> {{value}}</h6>
              </div>
              }
            </div>
            @if (shownote) {
            <div class="col  wow fadeInUp">
              <h6 class="text-break descText textfadecolor  notecolor">
                Note: All the Standard SAP ECC modules listed under SAP ECC Core Offerings are covered under this
                analysis.
              </h6>
            </div>
            }
          </div>
        </div>
        <!--/.Panel-->

      </div>
      <div class="col-lg-6 col-md-6 waves-light dottedBorder">
        <!--Panel-->
        <div class="card justify-content-center">
          <div class="card-header text-uppercase font-weight-bold"
            style="background: none; border: none; text-align: left;">
            <h5 class="text-uppercase font-weight-bold ">{{relatedLinksheader}}
            </h5>
          </div>
          <div class="card-body">
            @if (showofferingDeck) {
            <div class="list-group-item d-flex align-items-center">
              <i class="fas fa-file-download iconColor mr-1 margin"></i>
              <a href="{{url}}" target="_blank" (click)="onNavigate1('offering')" rel="noopener noreferrer"
                class="alink active" matTooltip="Click to open" matTooltipPosition="right">
                <h6>{{offeringDeckText}}
                </h6>
              </a>
            </div>
            }
            <div class="list-group-item d-flex align-items-center ">
              <i class="fa fa-link iconColor mr-1 margin" aria-hidden="true"></i>
              <a href="{{url}}" target="_blank" (click)="onNavigate1('demoLink')" rel="noopener noreferrer"
                class="alink active" matTooltip="Click to open" matTooltipPosition="right">
                <h6>Demo Link
                </h6>
              </a>
            </div>
            <div class="list-group-item d-flex align-items-center">
              <i class="fa fa-link iconColor mr-1 margin" aria-hidden="true"></i>
              <a href="javascript:void(0)" class="alink active wow fadeInUp" matTooltip="Click to open"
                matTooltipPosition="right" (click)="OpenDisclaimerpopup()">
                <h6>
                  Pre-Requisite Docket
                </h6>
              </a>
            </div>
            <div class="card-header text-uppercase font-weight-bold"
              style="background: none; border: none; text-align: left;">
              <h5 class="text-uppercase font-weight-bold ">{{deliverables}}
              </h5>
            </div>
            @if (showOutputDeck) {
            <div class="list-group-item d-flex align-items-center ">
              <i class="fas fa-file-download iconColor mr-1 margin"></i>
              <a href="javascript:void(0)" (click)="downloadFile('OutputDeck')" class="alink active"
                matTooltip="Click to download" matTooltipPosition="right">
                <h6>Sample Output Deck
                </h6>
              </a>
            </div>
            }
            <div class="list-group-item d-flex align-items-center ">

              <i class="fas fa-file-download iconColor mr-1 margin"></i>
              <a href="javascript:void(0)" (click)="downloadFile('offlineReport')" class="alink active"
                matTooltip="Click to download" matTooltipPosition="right">
                <h6>Sample Offline Reports

                </h6>
              </a>
            </div>
            <div class="list-group-item d-flex align-items-center ">

              <i class="fa fa-link iconColor mr-1 margin" aria-hidden="true"></i>
              <a href="{{url}}" target="_blank" (click)="onNavigate1('appLink')" rel="noopener noreferrer"
                class="alink active title" matTooltip="Click to open" matTooltipPosition="right">
                <h6>Sample Reports (Online ASD Portal)

                </h6>
              </a>
            </div>

            <div id="success" class="toast-alert alert-success hide mt-3 " role="alert" data-delay="1000"
              data-autohide="true" aria-live="assertive" aria-atomic="true">


              <div class="toast-body">
                <i class="fa fa-check" aria-hidden="true"></i>
                {{alertMsg}}
              </div>
            </div>

            @if (showFileDownloadInfo) {
            <div id="filedownloadmodalsuccess" class="toast-alert alert-info hide mt-3 " role="alert"
              aria-live="assertive" aria-atomic="true" data-autohide="false">
              <div class="toast-body">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                {{alertMsg}}
              </div>
            </div>
            }
            <div id="error" class="toast-alert alert-danger hide mt-3" role="alert" data-delay="5000"
              data-autohide="true" aria-live="assertive" aria-atomic="true">
              <div class="toast-body">
                <i class="fas fa-window-close" aria-hidden="true"></i>
                {{alertMsg}}
              </div>
            </div>
          </div>
        </div>
        <!--/.Panel-->

      </div>
      <!--Grid column-->

    </div>
  </div>
  <div class="modal-footer">
  </div>
</div>

